import React, { useEffect } from 'react';
import { Box, Button, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface UserAvailabilityProp {
  open: boolean;
  handleClose: () => void;
  remainingTime: number;
  setUserAvailabilityLeftTime: React.Dispatch<React.SetStateAction<number>>;
  setOpenuserAvailability: React.Dispatch<React.SetStateAction<boolean>>;
}
export const UserAvailability: React.FC<UserAvailabilityProp> = ({
  open,
  handleClose,
  remainingTime,
  setUserAvailabilityLeftTime,
  setOpenuserAvailability,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timerId = setInterval(() => {
      setUserAvailabilityLeftTime((prev) => {
        if (prev <= 1) {
          clearInterval(timerId);
          setOpenuserAvailability(false);
          window.location.href = '/';
          // navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [navigate]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="contentContainer">
        <h2 id="parent-modal-title" className="title">
          Are you still there?
        </h2>
        <p id="parent-modal-description" className="description">
          Reverting back to home with in {remainingTime}s
        </p>
        <Button className="cancel-btn btn" onClick={handleClose}>
          Yes
        </Button>
      </Box>
    </Modal>
  );
};
